export const isBrowser = () => typeof window !== 'undefined';

export const isInIframe = () => {
  if (!isBrowser()) return false;

  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

export const isInPopup = () => {
  return isBrowser() && !!window.opener;
};
